<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;" :getContainer="handleScollMain">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-form-item label="课程名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-input
                    placeholder="请输入课程名称"
                    v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入课程名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="课程介绍" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-textarea
                    placeholder="请输入课程介绍"
                    v-decorator="[
          'introduce',
          {rules: [{ required: false, message: '请输入课程介绍!' }],initialValue:info.introduce}
        ]"
                    :rows="4"
            />
          </a-form-item>

          <!--      <a-form-item label="课程分类" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                 <a-cascader
                   placeholder="请选择"
                   :options="treeData"
                   changeOnSelect
                   @change="treeChange"
                   allowClear
                   v-decorator="[
               'type',
               {rules: [{ required: true, message: '请选择课程分类!' }],initialValue:info.type}
             ]"
             :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                 />
               </a-form-item> -->
          <!-- <a-form-item label="主讲教师" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-input
              placeholder="请输入主讲教师"
              v-decorator="[
          'teachername',
          {rules: [{ required: false, message: '请输入主讲教师!' }],initialValue:info.teachername}
        ]"
            ></a-input>
          </a-form-item> -->
          <a-form-item label="主讲教师" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-select
                    v-decorator="[
          'teacherId',
          {rules: [{ required: true, message: '请选择主讲教师!' }],initialValue:info.teacherId}
          ]"
                    placeholder="请选择主讲教师"
                    @change="teacherChange"
                    showSearch
                    :filterOption="false"
                    @search="searchChange"
            >
              <a-select-option
                      :value="info.id"
                      v-for="(info, index) in teacherlist"
                      :key="index"
              >{{info.fullName}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="教师简介" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-textarea
                    placeholder="请输入教师简介"
                    v-decorator="[
          'teacherIntroduce',
          {rules: [{ required: false, message: '请输入教师简介!' }],initialValue:info.teacherIntroduce}
        ]"
                    :rows="4"
            />
          </a-form-item>
          <a-form-item label="开始时间" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-date-picker :showTime="{ format: 'HH:mm:ss' }"
                           format="YYYY-MM-DD HH:mm:ss"
                           v-decorator="[
          'startTime',
          {rules: [{ required: true, message: '请选择开始时间!' }],initialValue:info.startTime}
        ]"
            />
          </a-form-item>
          <a-form-item label="结束时间" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-date-picker :showTime="{ format: 'HH:mm:ss' }"
                           format="YYYY-MM-DD HH:mm:ss"
                           v-decorator="[
          'endTime',
          {rules: [{ required: true, message: '请选择结束时间!' }],initialValue:info.endTime}
        ]"
            />
          </a-form-item>

          <!--      <a-form-item label="使用有效期" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                 <a-select
                   v-decorator="[
               'ordereffective',
               {rules: [{ required: false, message: '请选择使用有效期!' }],initialValue:info.ordereffective}
             ]"
                   placeholder="请选择"
                 >
                   <a-select-option
                     :value="info.itemValue"
                     v-for="(info, index) in useValiditylist"
                     :key="index"
                   >{{info.itemName}}</a-select-option>
                 </a-select>
               </a-form-item> -->
          <!-- <a-form-item label="课程有效期" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-select
              v-decorator="[
          'fronteffective',
          {rules: [{ required: false, message: '请选择课程有效期!' }],initialValue:info.fronteffective}
        ]"
              placeholder="请选择"
            >
              <a-select-option
                :value="info.itemValue"
                v-for="(info, index) in useValiditylist"
                :key="index"
              >{{info.itemName}}</a-select-option>
            </a-select>
          </a-form-item> -->

          <!--  <a-form-item label="课程来源" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
             <a-select
               allowClear
               placeholder="请选择"
               v-decorator="[
           'coursefrom',
           {rules: [{ required: false, message: '请选择课程来源!' }],initialValue:info.coursefrom}
         ]"
             >
               <a-select-option
                 :value="info.id"
                 v-for="(info, index) in courseFromlist"
                 :key="index"
               >{{info.itemName}}</a-select-option>
             </a-select>
           </a-form-item> -->

          <a-divider id="detailInfo" orientation="left">详细信息</a-divider>

          <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" label="pc端详细介绍">
            <quill-editor v-model="info.pccontent" :options="editorOption" ref="QuillEditor"></quill-editor>
          </a-form-item>
          <a-upload
                  name="file"
                  :multiple="true"
                  :action="$api.file.uploadFile"
                  @change="handleEditorChange"
                  class="uploadImage"
                  style="display:none"
          >
            <a-button>
              <a-icon type="upload" />Click to Upload
            </a-button>
          </a-upload>
          <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" label="app详细介绍">
            <quill-editor v-model="info.appcontent" :options="editorOption" ref="QuillEditor2"></quill-editor>
          </a-form-item>
          <a-upload
                  name="file"
                  :multiple="true"
                  :action="$api.file.uploadFile"
                  @change="handleEditorChange2"
                  class="uploadImage"
                  style="display:none"
          >
            <a-button>
              <a-icon type="upload" />Click to Upload
            </a-button>
          </a-upload>

          <a-divider id="goodsphoto" orientation="left">课程图片</a-divider>

          <a-form-item label="图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-upload
                    :action="$api.file.uploadFile"
                    listType="picture-card"
                    :fileList="fileList"
                    @preview="handlePreview"
                    @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-divider id="goodsphoto" orientation="left">预告片</a-divider>

          <!--  <a-form-item label="视频" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
             <a-upload
               :action="$api.file.uploadFile"
               listType="picture-card"
               :fileList="fileListVideo"
               :beforeUpload="beforeUpload"
               @preview="handleVideoPreview"
               @change="handleVideoChange"
             >
               <div v-if="fileListVideo.length <1">
                 <a-icon type="plus" />
                 <div class="ant-upload-text">Upload</div>
               </div>
             </a-upload>
             <a-modal :visible="previewVideoVisible" :footer="null" @cancel="handleVideoCancel">
               <img alt="example" style="width: 100%" :src="previewVideo" />
             </a-modal>
           </a-form-item> -->
          <!-- <a-form-item label="视频时长" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-tooltip>
              <template slot="title">时长必须为整数</template>
           
               <a-input placeholder="请输入视频时长"
              v-decorator="[
          'totalTime',
          {rules: [{ required: true, message: '请输入视频时长!' }],initialValue:info.totalTime}
        ]"  />
            </a-tooltip>
          </a-form-item> -->

          <a-divider id="classHour" orientation="left">价格设置</a-divider>
          <a-form-item label="课程原价" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-input
                    placeholder="请输入课程原价"
                    v-decorator="[
          'originalPrice',
          {rules: [{ required: false, message: '请输入课程原价!' }],initialValue:info.originalPrice}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="课程现价" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-input
                    placeholder="请输入课程现价"
                    v-decorator="[
          'presentPrice',
          {rules: [{ required: false, message: '请输入课程现价!' }],initialValue:info.presentPrice}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="积分" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-input
                    placeholder="请输入积分"
                    v-decorator="[
          'jifen',
          {rules: [{ required: false, message: '请输入积分!' }],initialValue:info.jifen}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="是否免费" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-switch
                    v-model="info.isGratis"
                    v-decorator="[
          'isGratis',
          {rules: []}
        ]"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>

    </div>
  </a-spin>
</template>

<script>
  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["image"],
    ["clean"] // remove formatting button
  ];

  var that;
  var thisInfo = [];
  export default {
    props: {
      id: String,
      cInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        form: this.$form.createForm(this),
        dis: this.disabled,
        info: {
          status: true,
          type: [0],
          isGratis: true
        },
        treeData: [],
        fileList: [],
        fileListVideo: [],
        previewVisible: false,
        previewVideoVisible: false,
        previewImage: "",
        picArr: [],
        videoArr: [],
        previewVideo: "",
        isloading: false,
        loadingTip: "加载中...",
        regionDatas: [],
        courseValiditylist: [
          { id: 1, name: "一个月" },
          { id: 2, name: "三个月" },
          { id: 3, name: "六个月" }
        ],
        courseSourcelist: [],
        columnlist: [],
        courseFromlist: [],
        useValiditylist: [],
        LevelDatas: [],
        content: "",
        teacherlist: [],
        teacherlistNow: [],
        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions, // 工具栏
              handlers: {
                image: function(value) {
                  if (value) {
                    //alert("自定义图片");
                    document.querySelector(".uploadImage input").click();
                  } else {
                    this.quill.format("image", false);
                  }
                }
              }
            }
          }
        },

      };
    },
    mounted() {
      this.$nextTick(function() {
        that = this;
        this.getTree();
        this.getcolumnlist();//所属栏目列表
        this.getcourseFromlist();//课程来源列表
        this.getTeacherlist();//教师列表
        this.getuseValiditylist();//有效期列表
        if (this.id != 0) {
          //编辑
          this.getInfo();

        }
      });
    },
    components: {
      // zjInfo,
      // ksInfo
    },
    methods: {
      /**取消 */
      cancelClick() {
        this.$emit("callbackMethod");
      },
      sumbit() {
        this.$emit("callbackMethod");
      },
      treeChange(val) {
        this.info.type = val;
      },
      /**获取字典子项 */
      getcolumnlist() {
        //获取列表
        this.isloading = true;
        this.$api.dictionaryItem
                .getDictionaryItem(1)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.columnlist = res.data;
                  } else {
                    that.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      getcourseFromlist() {
        //获取列表
        this.isloading = true;
        this.$api.dictionaryItem
                .getDictionaryItem(2)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.courseFromlist = res.data;
                  } else {
                    that.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      getuseValiditylist() {
        //获取列表
        this.isloading = true;
        this.$api.dictionaryItem
                .getDictionaryItem(11)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.useValiditylist = res.data;
                  } else {
                    that.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      //分类
      getTree() {
        this.$api.courseType
                .getTreeByColumnId('','')
                .then(res => {
                  if (res.errorCode == this.$msg.responseCode.success) {
                    var allData = [
                      {
                        name: "根目录",
                        parentid: 0,
                        id: 0,
                        children: res.data
                      }
                    ];
                    this.treeData = allData;
                    this.info.type = [0];
                  } else {
                    this.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      /**回显栏目 */
      getParentChain(id) {
        this.$api.courseType
                .getParentIdList(id)
                .then(res => {
                  if (res.errorCode == this.$msg.responseCode.success) {
                    var infoSel = res.data;
                    infoSel.unshift(0);
                    this.info = thisInfo;
                    this.info.coursecolumn = Number(thisInfo.coursecolumn);
                    this.info.type = infoSel;
                  } else {
                    this.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      //详情
      getInfo() {
        this.isloading = true;
        this.$api.course
                .getById(this.id)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    if (res.data.type) {
                      this.info.isGratis = this.$commen.changeIntBoolean(res.data.isGratis);
                      res.data.isGratis = this.$commen.changeIntBoolean(res.data.isGratis);
                      thisInfo = res.data;
                      this.getParentChain(res.data.type);
                    } else {
                      this.info = res.data;
                      this.info.type = [0];
                    }

                    this.info.coursefrom = res.data.coursefrom;
                    this.info.coursecolumn = res.data.coursecolumn;
                    this.info.endTime = this.$moment(res.data.endTime, "YYYY-MM-DD HH:mm:ss");
                    this.info.startTime = this.$moment(res.data.startTime, "YYYY-MM-DD HH:mm:ss");
                    if(res.data.picUrl.length>0) {
                      var pics = res.data.picUrl.split(",");
                      for (var i = 0; i < pics.length; i++) {
                        this.fileList.push({
                          uid: i,
                          name: "课程图片" + (i + 1) + ".png",
                          status: "done",
                          url: pics[i]
                        });
                      }
                    }

                    if(res.data.videoUrl) {
                      var videos = res.data.videoUrl.split(",");
                      for (var i = 0; i < videos.length; i++) {
                        this.fileListVideo.push({
                          uid: i,
                          name: "课程视频" + (i + 1) + ".png",
                          status: "done",
                          url: videos[i]
                        });
                      }
                    }

                  } else {
                    this.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      //获取教师列表
      getTeacherlist() {
        this.isloading = true;
        this.$api.trainClass
                .getTeacherList()
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.teacherlist = res.data
                    // this.teacherlistNow=res.data.records;
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      //教师选择
      teacherChange(value) {
        if (value) {
          this.dis = false;
          // this.getGrouplist(value);
          this.getTeacherlist(value);
        }
      },
      searchChange(s) {
        if (s != "") {
          this.teacherlistNow = [];
          for (var i = 0; i < this.teacherlist.length; i++) {
            if(this.teacherlist[i].userName){
              if (this.teacherlist[i].userName.indexOf(s) > -1) {
                this.teacherlistNow.push(this.teacherlist[i]);
              }
            }

          }
        }
      },
      handleSubmit(e) {
        e.preventDefault();
        this.picArr=[];
        for(var i=0;i<this.fileList.length;i++) {
          if (this.fileList[i].url) {
            this.picArr.push(this.fileList[i].url);
          } else {
            this.picArr.push(this.fileList[i].response.data.path);
          }
        }
        this.videoArr=[];
        for(var i=0;i<this.fileListVideo.length;i++) {
          if (this.fileListVideo[i].url) {
            this.videoArr.push(this.fileListVideo[i].url);
          } else {
            this.videoArr.push(this.fileListVideo[i].response.data.path);
          }
        }

        this.form.validateFields((err, values) => {
          if (!err) {
          
            if (this.id != 0) {
              //修改
              this.isloading = true;
              this.$api.course
                      .update(
                              this.id,
                             
                              values.name,
                              this.info.type[this.info.type.length - 1],
                              values.introduce?values.introduce:'',
                              values.teacherId,
                              values.teacherIntroduce?values.teacherIntroduce:'',
                              1,
                              values.fronteffective?values.fronteffective:'',
                              values.ordereffective?values.ordereffective:'',
                              values.coursefrom?values.coursefrom:'',
                              1,
                              this.info.pccontent?this.info.pccontent:'',
                              this.info.appcontent?this.info.appcontent:'',
                              this.picArr?this.picArr.join(','):'',
                              this.videoArr?this.videoArr.join(','):'',
                              values.originalPrice?values.originalPrice:'',
                              values.presentPrice?values.presentPrice:'',
                              values.jifen?values.jifen:'',
                              values.isGratis
                                      ? this.$commen.changeBooleanInt(values.isGratis)
                                      : this.$commen.changeBooleanInt(this.info.isGratis),
                              0,
                              that.$moment(values.endTime).format("YYYY-MM-DD HH:mm:ss"),
                              that.$moment(values.startTime).format("YYYY-MM-DD HH:mm:ss"),
                      )
                      .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                          this.$message.success(res.errorMsg);
                          this.$emit("callbackMethod");
                        } else {
                          this.$message.error(res.errorMsg);
                        }
                      })
                      .catch(() => {
                        this.isloading = false;
                      });
            } else {
              //新增
              this.isloading = true;
              this.loadingTip = "保存中...";
              this.$api.course
                      .saveLive(
                              values.name,
                              this.info.type[this.info.type.length - 1],
                              values.introduce?values.introduce:'',
                              values.teacherId,
                              values.teacherIntroduce?values.teacherIntroduce:'',
                              1,
                              values.fronteffective?values.fronteffective:'',
                              values.ordereffective?values.ordereffective:'',
                              values.coursefrom?values.coursefrom:'',
                              1,
                              this.info.pccontent?this.info.pccontent:'',
                              this.info.appcontent?this.info.appcontent:'',
                              this.picArr?this.picArr:'',
                              this.videoArr?this.videoArr:'',
                              values.originalPrice?values.originalPrice:'',
                              values.presentPrice?values.presentPrice:'',
                              values.jifen?values.jifen:'',
                              values.isGratis
                                      ? this.$commen.changeBooleanInt(values.isGratis)
                                      : this.$commen.changeBooleanInt(this.info.isGratis),
                              that.$moment(values.startTime).format("YYYY-MM-DD HH:mm:ss"),
                              that.$moment(values.endTime).format("YYYY-MM-DD HH:mm:ss"),

                      )
                      .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                          this.$message.success(res.errorMsg);
                          this.$emit("callbackMethod",res.data);
                        } else {
                          this.$message.error(res.errorMsg);
                        }
                      })
                      .catch(() => {
                        this.isloading = false;
                      });
            }
          }
        });
      },
      getRegionList() {
        this.isloading = true;
        this.$api.system.dictionaryItem
                .list(1)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.regionDatas = res.data;

                    this.getLevelList();
                  } else {
                    //this.$message.error(res.errorMsg);
                    this.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                  this.error();
                });
      },
      getLevelList() {
        this.isloading = true;
        this.$api.system.dictionaryItem
                .list(3)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.LevelDatas = res.data;
                    if (this.id) {
                      this.info = this.cInfo;
                      this.info.status = this.cInfo.status == 1 ? true : false;
                    }
                  } else {
                    //this.$message.error(res.errorMsg);
                    this.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                  this.error();
                });
      },
      /**添加章节 */
      addzhangjie() {
        this.zjInfo.visible = true;
      },
      getaddzjInfo(data) {
        this.zjInfo.visible = false;
        this.zjlists.push({
          name: data
        });
      },
      /**添加课时 **/
      addks(){
        this.ksInfo.visible = true;
      },
      getaddksInfo(data) {
        this.ksInfo.visible = false;
        console.log(data)
      },
      /**上移下移 */
      handlemoveup(index) {
        // this.zjlists.splice(index - 1, 0, this.zjlists[index]);
        // //删除后一项
        // this.zjlists.splice(index + 1, 1);
        // if (index == 0) {
        //   this.$message.warning("已经到顶了!");
        // }
      },
      handlemovedown(index) {
        //在下一项插入该项
        this.zjlists.splice(index + 2, 0, this.zjlists[index]);
        // 删除前一项
        this.zjlists.splice(index, 1);
        item.isShow = false;
        if (index == this.zjlists.length - 1) {
          this.$message.warning("已经是最后一项啦！");
        }
      },
      /**添加课时 */

      error(msg) {
        this.$error({
          title: "提示",
          content: msg == undefined ? "服务器异常" : msg,
          okText: "返回",
          centered: true,
          onOk() {
            that.$emit("callbackMethod");
          }
        });
      },
      /**富文本上传图片 */
      handleEditorChange(info) {
        if (info.file.status == "done") {
          if (info.file.response.errorCode == this.$msg.responseCode.success) {
            // 获取富文本组件实例
            let quill = this.$refs.QuillEditor.quill;
            // 如果上传成功
            if (info.file.response.data.path) {
              // 获取光标所在位置
              let length = quill.getSelection().index;
              // 插入图片，res为服务器返回的图片链接地址
              quill.insertEmbed(length, "image", info.file.response.data.path);
              // 调整光标到最后
              quill.setSelection(length + 1);
            } else {
              // 提示信息，需引入Message
              Message.error("图片插入失败");
            }
          }
        }
      },
      /**富文本上传图片 */
      handleEditorChange2(info) {
        if (info.file.status == "done") {
          if (info.file.response.errorCode == this.$msg.responseCode.success) {
            // 获取富文本组件实例
            let quill = this.$refs.QuillEditor2.quill;
            // 如果上传成功
            if (info.file.response.data.path) {
              // 获取光标所在位置
              let length = quill.getSelection().index;
              // 插入图片，res为服务器返回的图片链接地址
              quill.insertEmbed(length, "image", info.file.response.data.path);
              // 调整光标到最后
              quill.setSelection(length + 1);
            } else {
              // 提示信息，需引入Message
              Message.error("图片插入失败");
            }
          }
        }
      },
      /**上传课程图片 */
      handleCancel() {
        this.previewVisible = false;
      },
      handlePreview(file) {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      },
      handleChange(info) {
        this.fileList = info.fileList;
      },

      /**上传课程视频 */
      handleVideoCancel() {
        this.previewVideoVisible = false;
      },
      beforeUpload(file) {
        const isMP4 = file.type === 'video/mp4';
        if (!isMP4) {
          this.$message.error('You can only upload MP4 file!');
        }
        const isLt1G = file.size / 1024 / 1024 < 1024;
        if (!isLt1G) {
          this.$message.error('Image must smaller than 1GB!');
        }
        return isMP4 && isLt1G;
      },
      handleVideoPreview(file) {
        this.previewVideo = file.url || file.thumbUrl;
        this.previewVideoVisible = true;
      },
      handleVideoChange(info) {
        this.fileListVideo = info.fileList;
      },
      handleScollMain() {
        return document.querySelector(".ant-modal-wrap");
      }
    }
  };
</script>
<style>
  .zjitem {
    border: 1px solid #e8e8e8;
    padding-left: 20px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .addzj,
  .moveup,
  .movedown {
    color: #1890ff;
  }
</style>